import api from "../api";

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Table,
  Badge,
  Container,
  Button,
  InputGroup,
  FormControl,
  Modal,
  Form,
  Dropdown,
} from "react-bootstrap";
import StateSelectUser from "./StateSelectForUser.jsx";

import { Eye, ThreeDotsVertical, Plus } from "react-bootstrap-icons";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedState, setSelectedState] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    username: "",
    password: "",
    mobile: "",
    assigned_state: [],
    status: 1, // default Active
    type: 0,
  });

  const handleStateSelectChange = (states) => {
    setSelectedState(states);

    setFormData((prev) => ({
      ...prev,
      assigned_state:
        states.length === 1 && states[0].value === ""
          ? []
          : states.map((s) => s.value),
    }));
  };
  const validate = () => {
    let newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      newErrors.name = "Name must contain only letters and spaces";
    }

    // Email validation
    if (!formData.username.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.username)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.mobile?.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }

    if (!selectedState || selectedState.length === 0) {
      newErrors.assigned_state = "Please select state / all states";
    }

    // Password validation
    if (!editMode) {
      // only require password for Add User
      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
          formData.password,
        )
      ) {
        newErrors.password =
          "Password must be 8+ chars, include uppercase, lowercase, number & special char";
      }
    } else if (formData.password) {
      // if editing and password is provided, validate it
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
          formData.password,
        )
      ) {
        newErrors.password =
          "Password must be 8+ chars, include uppercase, lowercase, number & special char";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get("/user");
      setUsers(res.data.map((u) => ({ ...u, status: Number(u.status) })));
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   api
  //     .get("/user") // replace with your backend API
  //     .then((res) => setUsers(res.data))
  //     .catch((err) => console.error(err));
  // }, []);

  const filteredUsers = users.filter(
    (u) =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.username.toLowerCase().includes(search.toLowerCase()),
  );

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const handleShowAdd = () => {
    setEditMode(false);
    setFormData({
      id: null,
      name: "",
      username: "",
      password: "",
      status: 1,
      mobile: "",
      assigned_state: [],
      type: 0,
    });
    setShowModal(true);
    setSelectedState([]);
  };

  const handleClose = () => setShowModal(false);

  // const handleChange = (e) => {
  //   // setFormData({ ...formData, [e.target.name]: e.target.value });
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: name === "status" ? Number(value) : value,
  //   }));
  // };

  const handleChange = (e) => {
    const { name, value, options, multiple } = e.target;

    let finalValue = value;

    if (multiple) {
      finalValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    }

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "status" || name === "type" ? Number(finalValue) : finalValue,
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     await api.post("/adduser", formData);
  //     // alert("User added successfully");
  //     toast.success("User added successful!");
  //     setShowModal(false);
  //     setFormData({ name: "", username: "", password: "", status: 1 });

  //     // reload updated users
  //     const res = await api.get("/user");
  //     setUsers(res.data);
  //   } catch (err) {
  //     console.error(err);
  //     // alert("Failed to add user");
  //     toast.error("Upload failed!");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return; // stop if validation fails
    try {
      const payload = {
        ...formData,
        status: Number(formData.status),
        type: Number(formData.type ?? 0),
        assigned_state:
          selectedState.length === 1 && selectedState[0].value === ""
            ? []
            : formData.assigned_state,
      };
      if (editMode && !payload.password) delete payload.password;

      if (editMode) {
        // update user
        await api.put(`/update/${payload.id}`, payload);
        console.log("Update", formData);
        toast.success("User updated successfully!");
      } else {
        // add new user
        await api.post("/adduser", payload);
        toast.success("User added successfully!");
      }

      setShowModal(false);
      fetchUsers();
    } catch (err) {
      console.error(err);
      toast.error("Operation failed!");
    }
  };

  const handleEdit = (user) => {
    setEditMode(true);
    // setFormData(user); // prefill form with selected user
    let parsedStates = [];

    if (Array.isArray(user.assigned_state)) {
      parsedStates = user.assigned_state;
    } else if (user.assigned_state) {
      try {
        parsedStates = JSON.parse(user.assigned_state);
      } catch {
        parsedStates = [];
      }
    }

    setFormData({
      id: user.id,
      name: user.name,
      username: user.username,
      password: user.password, // keep empty in edit
      mobile: user.mobile || "",
      assigned_state: parsedStates,
      status: Number(user.status),
      type: Number(user.type ?? 0),
    });
    setSelectedState(
      parsedStates.length > 0
        ? parsedStates.map((state) => ({ value: state, label: state }))
        : [{ value: "", label: "All States" }],
    );
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    try {
      await api.delete(`/delete/${id}`);
      toast.success("User deleted successfully!");
      fetchUsers();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete user!");
    }
  };

  const stateOptions = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh ",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal_Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Mumbai",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  return (
    <Container className="mt-4">
      <div className="card hptCard mt-4 border-0">
        <div className="card-body">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0"></h5>
            <div className="d-flex align-items-center gap-2">
              {/* <InputGroup style={{ maxWidth: "250px" }}>
              <FormControl
                placeholder="Search by here"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>  */}

              {/* Add New User Button */}
              <Button
                variant="dark"
                className="d-flex align-items-center w-100"
                onClick={handleShowAdd}
              >
                <Plus className="me-1" />
                Add User
              </Button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <Table className="table table-bordered ">
            <thead className="thead-light">
              <tr>
                <th className="text-center">SNo</th>
                <th>User</th>
                <th className="text-center">Created Date</th>
                <th className="text-center">Type</th>
                <th className="text-center">Last Login</th>
                <th className="text-center">Status</th>
                <th className="text-center"> Action</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((u, index) => (
                <tr key={u.id}>
                  <td className="text-center">{index + 1}</td>
                  <td>
                    <div>
                      <strong>{u.name}</strong>
                      <br />
                      <small className="text-muted">{u.username}</small>
                    </div>
                  </td>
                  <td className="text-center">
                    {new Date(u.createdDate).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      // hour: "2-digit",
                      // minute: "2-digit",
                      // hour12: true,
                    })}
                  </td>
                  <td className="text-center">
                    <Badge
                      bg="light"
                      text={u.type === 1 ? "danger" : "success"}
                      className={`border ${
                        u.type === 1 ? "border-danger" : "border-success"
                      } px-3 py-2`}
                    >
                      {u.type === 1 ? "External" : "Internal"}
                    </Badge>
                  </td>
                  <td className="text-center">
                    {u.lastLogin
                      ? new Date(u.lastLogin).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                      : "Never"}
                  </td>
                  <td className="text-center">
                    {(() => {
                      const s = Number(u.status);
                      return (
                        <Badge
                          pill
                          bg="light"
                          text={s === 1 ? "success" : "danger"}
                          className={`border ${
                            s === 1 ? "border-success" : "border-danger"
                          } px-3 py-2`}
                        >
                          {s === 1 ? "Active" : "Inactive"}
                        </Badge>
                      );
                    })()}
                  </td>
                  <td className="text-center">
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        as={Button}
                        variant="link"
                        className="p-0"
                        id={`dropdown-${u.id}`}
                      >
                        <ThreeDotsVertical />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleEdit(u)}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDelete(u.id)}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {indexOfFirstUser + 1} to{" "}
          {Math.min(indexOfLastUser, filteredUsers.length)} of{" "}
          {filteredUsers.length} users
        </div>

        <div className="d-flex gap-2">
          <Button
            variant="light"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Prev
          </Button>

          {[...Array(totalPages)].map((_, i) => (
            <Button
              key={i}
              variant={currentPage === i + 1 ? "dark" : "light"}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Button>
          ))}

          <Button
            variant="light"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      </div>

      {/* Add User Modal */}
      <Modal show={showModal} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? "Edit User" : "Add New User"}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="username"
                value={formData.username}
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="*********"
                value={formData.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>User Type</Form.Label>
              <Form.Select
                name="type"
                value={String(formData.type)}
                onChange={handleChange}
              >
                <option value="0">Internal</option>
                <option value="1">External</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                name="status"
                value={String(formData.status)}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                isInvalid={!!errors.mobile}
                maxLength={10}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobile}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <StateSelectUser
                stateList={stateOptions}
                selectedState={selectedState}
                setSelectedState={handleStateSelectChange}
                width="100%"
              />
              {errors.assigned_state && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                >
                  {errors.assigned_state}
                </div>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="dark" type="submit">
              {editMode ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}
